import { gql } from "@apollo/client";

export interface LCDevice {
	device_id: number
	cpu_id: string
	power_supply: number
	max_ac_ports: number
	device_type: number
}


export const LC_DEVICE = gql`
query GetLcDevice($domain: String!, $lanControllerId: Int!) {
	controller {
		lcDevice(domain: $domain, lanControllerId: $lanControllerId) {
			device_id
			cpu_id
			power_supply
			max_ac_ports
			device_type
		}
	}
}
`

export interface LCDeviceResponse {
	controller: {
		lcDevice: LCDevice[] | null
	}
}

export interface LCDeviceArgs {
	domain: string;
	lanControllerId: number;
}

